import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-ui-kit',
  templateUrl: './ui-kit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiKitComponent {
  components: string[] = [
    'Typography',
    'Button',
    'Icon button',
    'Badge',
    'Avatar',
    'Radio',
    'Checkbox',
    'Toggle',
    'Input',
    'Icon',
    'Select',
    'Navigation'
  ];
  currentComponent: string = this.components[0];

  radioChecked: boolean = false;
  radio?: string;
  checkboxChecked: boolean = true;
  toggle: boolean = false;
  dropdownOptions = [
    {
      label: 'label1',
      value: 'value1'
    },
    {
      label: 'label2',
      value: 'value2'
    },
    {
      label: 'label',
      value: 'value4'
    }
  ];
  page = 0;
  selectedDropdownOption1: string[] = [];
  selectedDropdownOption2 = '';
  numOfInputs = Array.from({ length: 20 }, (_, i) => i + 1);
  window_alert() {
    alert();
    document.body.classList.remove('h-screen', 'overflow-y-hidden');
  }
}
